import { useQuery } from "@tanstack/react-query";
import { useCommonStore } from "../../store";
import { getSolutionApi } from "../../services/solution/get.solution.api";
import { getResultApi } from "../../services/result/get.result.api";

export const useGetAllResultApi = () => {
  const { reload } = useCommonStore();
  const { data, isLoading } = useQuery({
    queryKey: ["result", reload],
    queryFn: () => getResultApi(),
    enabled: true,
  });
  return {
    result: data,
    isLoading,
  };
};
